import { useDispatch } from "react-redux";
import { useLazyBuyNowQuery } from "../../../../../toolkit/buyNow/buyNowApi";
import { editAlertDialog, resetAlertDialog, setAlertDialog } from "../../../../../toolkit/alertDialog/alertDialogSlice";

const useBuyNow = () => {

  const dispatch = useDispatch();

  const [buyNowApiHandler, buyNowApiData] = useLazyBuyNowQuery();

  const buyNowHandler = async ({
    Vehicle_Id,
    onCloseCb
  }) => {
    dispatch(
      setAlertDialog({
        open: true,
        title: `Alert!`,
        message: `Are you sure you want to purchase this car?`,
        avoidCloseOnOK: true,
        onOk: async () => {

          dispatch(
            editAlertDialog({
              isLoading: true
            })
          );

          const res = await buyNowApiHandler({
            Vehicle_Id
          });

          if (res?.isError || ("status" in res?.data && !res?.data?.status)) {
            dispatch(
              setAlertDialog({
                open: true,
                title: `Error!`,
                isLoading: false,
                message: res?.error?.data?.error || res?.error?.data?.message
                  || res?.data?.message || `Some error occured in buying the car. Please try again!`
              })
            );
            return;
          } else {
            dispatch(
              setAlertDialog({
                open: true,
                title: `Success!`,
                message: `Car purchased successfully!`,
                isLoading: false,
                onClose: () => {
                  if (onCloseCb) {
                    onCloseCb();
                  }
                }
              })
            );
          }
        }
      })
    );
  };
  
  return {
    buyNowHandler
  };
}

export {
  useBuyNow
};